import {
  Text,
} from '@fluentui/react';
import { ISubscription } from "@/services/SubscriptionService";
import { formatAmount } from '../util';

type TInfoPanel = {
    selectedPlan: ISubscription;
}

const BASE_CLASS = "infoPanel";

const InfoPanel: React.FC<TInfoPanel> = ({ selectedPlan }) => (
        <div className={BASE_CLASS}>
          <div className={`${BASE_CLASS}__container`}>
            <h3 className={`${BASE_CLASS}__planName`}>
              {selectedPlan.name}
            </h3>
            <div className={`${BASE_CLASS}__planPrice`}>
              {selectedPlan.price && selectedPlan.price.toFixed(2).replace('.', ',')} €{' '}
              <span className={`${BASE_CLASS}__planLimit`}>/año</span>
            </div>
            <div className={`${BASE_CLASS}__planLimit`}>
              <p>Límite de cartera:</p>
              <strong>{selectedPlan.limit ? `${formatAmount(selectedPlan.limit)}` : 'Sin límites.'}</strong>
            </div>
            <Text className={`${BASE_CLASS}__bodyText`}>
                El límite marca el volumen total de la cartera. Si se supera el límite no se pueden realizar más compras de fondos o traspasos con esa suscripción.
            </Text>
            <Text className={`${BASE_CLASS}__hint`}>
              Pulsa en cualquier otra barra para cambiar tu selección.
            </Text>
          </div>
          <div className={`${BASE_CLASS}__container`}>
            <h3 className={`${BASE_CLASS}__planName`}>
              Descripción
            </h3>
            <Text className={`${BASE_CLASS}__bodyText`}>
              {selectedPlan.description}
            </Text>
          </div>

        </div>
        );


export default InfoPanel;